<app-protected-content [requiredRoles]="requiredRoles">
  @let systems = systems$ | async;
  <div class="dashboard-card-container">
    @if (systems === null) {
      @for (i of [].constructor(numberOfDashboardCards); track $index) {
        <app-dashboard-card [loading]="true"></app-dashboard-card>
      }
    } @else {
      @for (system of systems; track system.name) {
        <app-dashboard-card
          [systemKey]="system.name"
          [healthStatus]="system.status"
        ></app-dashboard-card>
      }
    }
  </div>
</app-protected-content>
